import axios from "axios";
import { api } from "./api_route";

export const createArbitratorDetailsAPI = async (arbitratorDetailsData) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      arbitratorDetailsData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/arbitratorDetails/create`,
      arbitratorDetailsData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getArbitratorDetailsByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(`${api}/arbitratorDetails/case/${caseID}`);
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateArbitratorDetailsAPI = async (
  arbitrator_ID,
  arbitratorDetailsData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      arbitratorDetailsData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/arbitratorDetails/update/${arbitrator_ID}`,
      arbitratorDetailsData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteArbitratorDetailsAPI = async (arbitrator_ID) => {
  try {
    const response = await axios.delete(
      `${api}/arbitratorDetails/delete/${arbitrator_ID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const arbitratorResendCertificateAPI = async (id) => {
  try {
    const response = await axios.post(`${api}/boardsAndPanel/arbitratorResendCertificate/${id}`);
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const arbitratorEmpanelRenewalStatusAPI = async (id) => {
  try {
    const response = await axios.post(`${api}/boardsAndPanel/arbitratorEmpanelRenewalStatus/${id}`);
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const mediatorEmpanelRenewalStatusAPI = async (id) => {
  try {
    const response = await axios.post(`${api}/boardsAndPanel/mediatorEmpanelRenewalStatus/${id}`);
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};
